import { put, call, select, takeEvery, takeLatest } from "redux-saga/effects";

import * as apis from "../../network/apis/demoRequests";
import * as types from "./types";
import * as actions from "./actions";
import messages from "../../assets/locale/messages";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

function* getDemoRequestsListSaga({ payload }) {
  try {
    const response = yield call(apis.getDemoRequestsList, payload);
    yield put(
      actions.getDemoRequestsResponse({
        list: response.data.data,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getDemoRequestsRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* updateDemoRequestSaga({ payload }) {
  try {
    const { id, data, listParams } = payload;
    yield call(apis.updateDemoRequest, { id, data });
    yield call(showSuccessMsg, "updatedSuccessfully");
    yield put(actions.getDemoRequestsRequest(listParams));
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

function* deleteDemoRequestSaga({ payload }) {
  try {
    const { id, name, listParams } = payload;
    yield call(apis.deleteDemoRequest, id);
    const lang = yield select((state) => state.locale.lang);
    const toast = messages[lang].demoRequests.listDemoRequests;
    yield call(
      showSuccessMsg,
      toast.removedToastBody.replace("{name}", name || ""),
      true,
      toast.removedToastTitle,
    );
    yield put(actions.getDemoRequestsRequest(listParams));
  } catch (error) {
    yield error.response && showErrorMsg(error.response?.data?.message);
  }
}

export default function* DemoRequestsSagas() {
  yield takeLatest(types.GET_DEMO_REQUESTS_REQUEST, getDemoRequestsListSaga);
  yield takeEvery(types.UPDATE_DEMO_REQUEST_REQUEST, updateDemoRequestSaga);
  yield takeEvery(types.DELETE_DEMO_REQUEST_REQUEST, deleteDemoRequestSaga);
}
